import React,{useState,useEffect} from 'react';
import SidebarItem from './SidebarItemResto';
import data from '../Data/dataResto.json';
import Logo from '../Image/logo.png';

const SidebarResto = ({ hide, logout, restaurant }) => {
  //  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const options = { day: 'numeric' };
  var opt_weekday = { weekday: 'long' };
  var opt_month = { month: 'long' };
  const today = new Date();
  var weekday = toTitleCase(today.toLocaleDateString("fr-FR", opt_weekday));
  var Month = toTitleCase(today.toLocaleDateString("fr-FR", opt_month));

  function toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }
  
  
  const dateFormat = (date) => {
    if (date < 10) {
      return '0' + date;
    } else {
      return date;
    }
  }

  const [countDown, setCountDown] = useState(dateFormat(new Date().getHours())+":"+ dateFormat(new Date().getMinutes()));
  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(dateFormat(new Date().getHours())+":"+ dateFormat(new Date().getMinutes()));
    }, 1000);

    return () => clearInterval(interval);
  });
  const [selected, setSelected] = useState(0);
  const toogle = (i) => {
    if (selected === i) {
      setSelected(null);
    }
    setSelected(i);
  }

  return (
    <div className='sidebar d-flex flex-column h-100 justify-content-between'>
      <div className='bloc_sidebar'>
        <div className='bg-white pt-2'>
          <div className='d-flex justify-content-end close_button'>
            <i className='fa fa-close' onClick={() => hide()}></i>
          </div>
          <div className='d-flex justify-content-center '>
            <div className='logo'>
              <img src={Logo} alt='logo e-kaly' width="160px" height="57px" title="logo e-kaly" />
            </div>
          </div>
        </div>
        <div className='description_resto'>
          <div className='d-flex justify-content-between'>
            <span className='date'>{weekday + " " + today.toLocaleDateString("fr-FR", options) + " " + Month}</span>
            <span className='heure'>{countDown}</span>
          </div>
          <span className='nomResto'>{restaurant.nomRestaurant}</span>
        </div>
        {data.map((item, index) => <SidebarItem key={index} i={index} selected={selected} toogle={toogle} item={item} />)}
      </div>
      <div className='bloc_deconnection'>
        <div className='d-flex justify-content-center'>
          <button className='btn' onClick={() => logout()}><i className='fa fa-power-off'></i>Je me déconnecte</button>
        </div>
      </div>
    </div>
  )
}

export default SidebarResto